// generated by srcset-codegen
import src from "./trash-black.svg";

const width = 16;
const height = 16;
export default { src, width, height };
